export default __webpack_public_path__ + "static/media/mobile.14d2acf1.png";